/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_ExportInputs */

const en_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export format`)
};

const de_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportformat`)
};

const fr_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format d'export`)
};

const es_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de exportación`)
};

const it_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato esportazione`)
};

const nl_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportformaat`)
};

const pl_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format eksportu`)
};

const fi_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vientimuoto`)
};

const da_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksportformat`)
};

const sv_pricing_compare_export = /** @type {(inputs: Pricing_Compare_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportformat`)
};

/**
* | output |
* | --- |
* | "Export format" |
*
* @param {Pricing_Compare_ExportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_export = /** @type {((inputs?: Pricing_Compare_ExportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_ExportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_export(inputs)
	if (locale === "fr") return fr_pricing_compare_export(inputs)
	if (locale === "es") return es_pricing_compare_export(inputs)
	if (locale === "it") return it_pricing_compare_export(inputs)
	if (locale === "nl") return nl_pricing_compare_export(inputs)
	if (locale === "pl") return pl_pricing_compare_export(inputs)
	if (locale === "fi") return fi_pricing_compare_export(inputs)
	if (locale === "da") return da_pricing_compare_export(inputs)
	if (locale === "sv") return sv_pricing_compare_export(inputs)
	return en_pricing_compare_export(inputs)
});